import React, { useEffect } from 'react';
import { Container, Typography, Box, Chip, Stack } from '@mui/material';
import { EmployeeDataTable } from './EmployeeDataTable';
import { useAppDispatch } from '../../store';
import { useNavigate } from 'react-router-dom';
import { VillaRounded } from '@mui/icons-material';

export const EmployeesPage = () => {
  const navigate = useNavigate();
  const dispath = useAppDispatch();

  const handleOnVacationsOnClick = () => {
    navigate(`/home/employees/vacations`);
  };

  return (
    <Container disableGutters>
      <Stack direction="row" spacing={2} sx={{ alignItems: 'center', mb: 5 }}>
        <Box>
          <Typography component="span" variant="h5" mt={2} mb={5}>Employees</Typography>
        </Box>
        <Chip icon={<VillaRounded />} color='info' onClick={handleOnVacationsOnClick} label="On Vacations" />
      </Stack>
      <EmployeeDataTable />
    </Container>
  );
};